import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form, Table } from "react-bootstrap";
import GoalsTable from "client_config/GoalsTable";
import ConfigureGoalsModal from "client_config/ConfigureGoalsModal";
import jsDig from "utils/jsDig";
import allMetrics from "data/allMetrics.js";
import { snakeCase, cloneDeep } from "lodash";
import CustomFormCheck from "utils/CustomFormCheck";

const allMetricData = allMetrics();

export default function Goals(props) {
  props.pageLocator();
  const metricList = props.metricList;
  const startDate = moment("2018-01-01");
  const todaysDate = moment();
  const endDate = todaysDate.add(1, "year");
  const yearsDiff = Math.ceil(endDate.diff(startDate, "years", true));
  const yearsArray = [...Array(yearsDiff)].map((empty, index) => startDate.year() + index).reverse();
  const [goalChangePercent, setGoalChangePercent] = useState(0);
  const [allOrBlank, setAllOrBlank] = useState("blank");

  let calculatorLarge = require("images/icons/calculator-large.png");
  calculatorLarge = <img src={`/datapulse${calculatorLarge}`} />;
  const [selectedDashboardId, setSelectedDashboardId] = useState(props.dashboards[0].id);
  const [selectedYear, setSelectedYear] = useState(moment().year().toString());

  let savedCheckedMetrics = {};

  props.dashboards.forEach((dashboard) => {
    savedCheckedMetrics[dashboard.id] = {};
    yearsArray.forEach((year) => {
      // Get a list of which metrics have been saved to the dashboard's goals
      let goals = jsDig(["goals", year, "Jan"], dashboard);
      if (props.service && Object.keys(dashboard.goals).length == 0) {
        goals = allMetricData.metricsByDashboard[`${props.service}`].defaults[`${props.client_account.account_type}`].goalsAndProjections;
      }
      savedCheckedMetrics[dashboard.id][year] = goals ? Object.keys(goals).map((metricName) => metricName) : [];
    });
  });
  const [checkedMetrics, setCheckedMetrics] = useState(savedCheckedMetrics);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const handleMetricCheck = (id, year, metricName, check) => {
    let newCheckedMetrics = cloneDeep(checkedMetrics);
    if (check && jsDig([id, year], newCheckedMetrics)) {
      newCheckedMetrics[id][year].push(metricName);
    } else {
      newCheckedMetrics[id][year].splice(newCheckedMetrics[id][year].indexOf(metricName), 1);
    }

    let newDashboards = cloneDeep(props.dashboards);
    const index = newDashboards.findIndex((el) => el.id == id);
    newDashboards[index]["goals"][year] = {};
    newCheckedMetrics[id][year].forEach((metricName) => {
      months.forEach((month) => {
        if (!newDashboards[index]["goals"][year][month]) newDashboards[index]["goals"][year][month] = {};
        newDashboards[index]["goals"][year][month][metricName] = jsDig([year, month, metricName], props.dashboards[index]["goals"])
          ? props.dashboards[index]["goals"][year][month][metricName]
          : "";
      });
    });

    let newGoals = cloneDeep(props.goals);
    newDashboards.forEach((el) => {
      newGoals[props.service][el.id] = el.goals;
    });
    props.setGoals(newGoals);
    props.setDashboards([...newDashboards]);
    setCheckedMetrics(newCheckedMetrics);
  };

  const handlePullMetric = (selectedId) => {
    const data = `${props.service}_cc_data`;
    if (props[data][selectedId]) {
      const year = moment().year();
      const percentChange = goalChangePercent / 100;
      // The cc data sent by the controller includes all platforms, so filter to only 'all'
      const allCcData = props[data][selectedId].filter((datum) => datum.platform == "all");
      let newDashboards = props.dashboards;
      const dashIndex = newDashboards.findIndex((el) => el.id == selectedId);
      // Reformat cc data to make it easier to access
      const ccData = {};
      allCcData.forEach((datum) => {
        let newDate = moment(datum.date.split("T")[0]);

        const newMonth = newDate.format("MMM");
        const newyear = newDate.format("YYYY");
        if (!ccData[newyear]) ccData[newyear] = {};
        ccData[newyear][newMonth] = datum;
      });

      // Only apply the changes to the metrics that have been checked
      const goalShortcutMetrics = $('.metric-selector input[type="checkbox"]:checked');
      
      months.forEach((month) => {
        goalShortcutMetrics.each((i, metricCheckbox) => {
          const metricCamel = metricCheckbox.name;
          const metricSnake = snakeCase(metricCamel);
          const historical = jsDig([year - 1, month, metricSnake, "projected"], ccData);
          const newValue = Math.round(historical * (1 + percentChange)  * 100) / 100;
          if (allOrBlank == "blank") {
            if (historical && newDashboards[dashIndex].goals[year][month][metricCamel] == "") {
              newDashboards[dashIndex].goals[year][month][metricCamel] = newValue;
            }
          } else {
            if (historical) {
              newDashboards[dashIndex].goals[year][month][metricCamel] = newValue;
            }
          }
        });
      });
      props.setDashboards([...newDashboards]);
    } else {
      console.log("No historical data!");
    }
  };

  return (
    <>
      <Row style={{ paddingTop: "25px", paddingLeft: "62px" }} className="justify-content-between collapse-padding-mobile">
        <Col xl={4}>
          <div className="pb-4">
            <div className="table-responsive ml-0" style={{ maxWidth: props.onboarding ? "200px" : undefined }}>
              <Table>
                <tbody>
                  {!props.onboarding && (
                    <tr>
                      <td className="pl-0 text-left goalYear">For:</td>
                      <td>
                        <Form.Control
                          style={{ width: "277px" }}
                          className="d-inline-block primary"
                          disabled={props.service == "ppc" ? true : false}
                          as="select"
                          input="text"
                          size="sm"
                          value={selectedDashboardId}
                          onChange={(e) => {
                            setSelectedDashboardId(e.target.value);
                          }}>
                          {props.dashboards.map((dashboard, index) => (
                            <option key={index} value={dashboard.id}>
                              {dashboard.name}
                            </option>
                          ))}
                        </Form.Control>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td className="pl-0 text-left goalYear">Year:</td>
                    <td>
                      <Form.Control
                        className="primary"
                        as="select"
                        style={{ maxWidth: "120px" }}
                        defaultValue={selectedYear}
                        onChange={(e) => {
                          setSelectedYear(e.target.value);
                        }}>
                        {yearsArray.map((year) => {
                          return <option key={year}>{year}</option>;
                        })}
                      </Form.Control>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            
            {/* Only show the pull metrics button if the selectedYear matches the current year */}
            { selectedYear == moment().year().toString() ? (
              <>
                { props[`${props.service}_cc_data`][selectedDashboardId].length > 0 ? (
                  <div style={{ marginLeft: "2px" }} className="pt-4 text-center text-md-left goal-shortcuts">
                    <p className="pb-1 f14 nunito-regular light-primary text-left">
                      You have the option to pull in historical data from the last year to help set this year's goals. Enter a percentage change to apply to the previous year's data:
                    </p>
                    <p className="pb-2 f14 nunito-regular light-primary text-left">
                      (Negative numbers are also supported)
                    </p>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "12px", maxWidth: "100px", position: "relative"}}>
                      <Form.Control
                        className="primary"
                        size="sm"
                        as="input"
                        type="number"
                        style={{ paddingLeft: "20px" }}
                        value={goalChangePercent}
                        onChange={(e) => setGoalChangePercent(e.target.value)}
                      >
                      </Form.Control>
                      <span style={{ position: "absolute", right: "10px", top: "4px" }}>%</span>
                    </div>

                    <div className="metric-selector text-left" style={{marginTop: "12px", display: "flex", flexDirection: "column"}}>
                      <p style={{fontWeight: "bold", width: "100%", marginBottom: "2px"}}>Metrics to fill in:</p>
                      {/* Let the user select which metric to apply the change to. Generate a checkbox for each metric */}
                      {checkedMetrics[selectedDashboardId][selectedYear].map((metricName, index) => {
                        const metric = metricList[metricName];
                        return (
                          <div key={index} className="metric-checkbox" style={{marginRight: "12px"}}>
                            <CustomFormCheck
                              id={`goal-shortcut-${metricName}`}
                              label={metric.name.shortened}
                              name={metricName}
                              static
                            />
                          </div>
                        );
                      })}
                    </div>

                    <div className="all-or-blank text-left" style={{marginTop: "12px", display: "flex", flexDirection: "column"}}>
                      <p style={{fontWeight: "bold", width: "100%", marginBottom: "12px"}}>Goals to replace:</p>
                      <Form.Control
                        className="primary"
                        size="sm"
                        as="select"
                        style={{ paddingLeft: "20px" }}
                        value={allOrBlank}
                        onChange={(e) => setAllOrBlank(e.target.value)}>
                        <option value={"blank"}>Only blank fields</option>
                        <option value={"all"}>All fields</option>
                      </Form.Control>
                    </div>

                    <Button
                      style={{ paddingLeft: "45px", paddingRight: "45px" }}
                      variant="success"
                      size="sm"
                      className="mt-3"
                      onClick={() => handlePullMetric(selectedDashboardId)}>
                      Pull metrics
                    </Button>
                  </div>
                ) : (
                  <p className="pt-4">No historical data has been pulled so goals cannot be generated.</p>
                )}
              </>
            ) : <> </> }
          </div>
        </Col>
        <Col xl={4} lg={"auto"}>
          <div>
            <p className="pb-2">Configure which metrics for the selected for/year fields that you would like to set goals for:</p>
            <div className="configure-goals-btn">
              <ConfigureGoalsModal
                onboarding={props.onboarding}
                submitForm={props.submitForm}
                service={props.service}
                dashboards={props.dashboards}
                setDashboards={props.setDashboards}
                accountType={props.client_account.account_type}
                selectedDashboardId={selectedDashboardId}
                setSelectedDashboardId={setSelectedDashboardId}
                handleMetricCheck={handleMetricCheck}
                checkedMetrics={checkedMetrics[selectedDashboardId][selectedYear]}
                selectedYear={selectedYear}
                metricList={metricList}
                setCheckedMetrics={setCheckedMetrics}
              />
            </div>
          </div>
        </Col>
        <Col xl={3} lg={"auto"} style={{ paddingRight: "60px" }} className="collapse-padding-mobile">
          <div className="p-3" style={{ backgroundColor: "#e1e1e1" }}>
            <div className="row pl-3 pb-2">
              {calculatorLarge} <p className="pl-3 f16 visby-bold text-info">What's this?</p>
            </div>
            <div>
              <p className="f12">
                When you see the blue calculator icon on a goal or column, it means that this metric can be auto-generated using pre-existing information. For
                example, ROAS can be auto-generated based on the existing Spend and Revenue goals. Hover over the icon to get information on which metrics it
                needs to calculate, and click to generate into that field.
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-5" style={{ paddingTop: "25px", paddingLeft: "32px" }}>
        <Col>
          {props.dashboards.map((dashboard, dbIndex) => {
            return (
              <React.Fragment key={dbIndex}>
                {yearsArray.map((year, yearIndex) => {
                  let visible = dashboard.id == selectedDashboardId && selectedYear == year;
                  return (
                    <div style={{ display: visible ? "block" : "none" }} key={yearIndex}>
                      <GoalsTable
                        service={props.service}
                        dashboard={dashboard}
                        year={year}
                        checkedMetrics={checkedMetrics[dashboard.id][year]}
                        metricList={metricList}
                        onboarding
                        goals={props.goals}
                        setGoals={props.setGoals}
                      />
                    </div>
                  );
                })}
              </React.Fragment>
            );
          })}
        </Col>
      </Row>
    </>
  );
}
